const productCategories = {
	bijelo: {
		key: 'bijelo',
		label: 'Bijelo Vino',
		type: 0,
	},
	rose: {
		key: 'rose',
		label: 'Rose Vino',
		type: 1,
	},
	crno: {
		key: 'crno',
		label: 'Crveno Vino',
		type: 2,
	},
	pjenusavo: {
		key: 'pjenusavo',
		label: 'Pjenušavo Vino',
		type: 3,
	},
	rakija: {
		key: 'rakija',
		label: 'Destilat',
		type: 4,
	},
};
export default productCategories;
